require('slick-carousel');

const moreBookingsCarousel = require('../../components/moreBookingsCarousel').moreBookingsCarousel;

function benefitsSlider() {
    $('.benefits-whatever__slider').slick({
        adaptiveHeight: true,
        slidesToShow: 3,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    adaptiveHeight: true,
                    slidesToShow: 2,
                    variableWidth: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    variableWidth: true,
                }
            }
        ]
    });
}

benefitsSlider();
new moreBookingsCarousel();


